import dayjs from "dayjs"
import { useCallback, useMemo } from "react"
import { Flex } from "@chakra-ui/layout"
import { useTranslation } from "react-i18next"

function formatDate(date: Date) {
  return dayjs(date).format("D MMM, HH:mm")

}

function format24Time(date: Date) {
  return dayjs(date).format("HH:mm")
}

type ShowDateOverlayProps = {
  date: string
}

const ShowDateOverlay = ({ date }: ShowDateOverlayProps) => {
  const { t } = useTranslation()

  const formatDateTime = useCallback(
    (_date: Date) => {
      if (!_date) return null

      const today = new Date()
      const tomorrow = new Date(today)
      tomorrow.setDate(today.getDate() + 1)

      if (_date.toDateString() === today.toDateString()) {
        return `${t("Today")}, ${format24Time(_date)}`
      } else if (_date.toDateString() === tomorrow.toDateString()) {
        return `${t("Tomorrow")}, ${format24Time(_date)}`
      } else {
        return formatDate(_date)
      }
    },
    [t]
  )

  const time = useMemo(() => {
    if (!date) return null
    const dateObj = new Date(date)

    // if date is less the current date then don't show date by returning null
    if (dateObj.getTime() < Date.now()) return null

    return formatDateTime(dateObj)
  }, [date, formatDateTime])

  if (!time) return null

  return (
    <Flex
      backgroundColor={"rgba(255, 255, 255, 0.8)"}
      fontWeight="semibold"
      color="black"
      paddingX={2}
      paddingY="2px"
      rounded="5px"
      justifyContent="center"
      alignItems="center"
      fontSize="12px"
    >
      {time}
    </Flex>
  )
}

export default ShowDateOverlay
